<template>
  <div class="index" v-cloak style="background-color: #f2f2f2">
    <div class="header acea-row acea-row-back row-center-wrapper">
      <div class="dingwei"><span></span>{{ city }}</div>
      <router-link :to="'/search'" class="search acea-row row-middle">
        <span class="iconfont icon-xiazai5"></span>搜索门店
      </router-link>
    </div>
    <div class="nav acea-row list lianjie">
      <router-link
        class="item"
        style="width: 20%"
        v-for="(item, index) in categoryList"
        :key="index"
        :to="{
          path: '/shop/storeList',
          query: { cateId: item.id }
        }"
      >
        <div class="pictrue">
          <img :src="item.pic" />
        </div>
        <div class="business" style="font-weight: bold">
          {{ item.cateName }}
        </div>
      </router-link>
    </div>
    <div class="storeList" v-if="storeList.length > 0">
      <div>
        <div class="hot-bg">
          <div class="title acea-row row-between-wrapper">
            <div class="text line1">
              <span class="label ">门店优选</span>
            </div>
            <router-link :to="{ path: '/shop/storeList/details' }" class="more">
              更多
              <span class="iconfont icon-jiantou"></span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="list acea-row row-middle">
        <router-link
          :to="{ path: '/storedetails/' + item.deptId }"
          class="item"
          v-for="(item, index) in storeList"
          :key="index"
        >
          <div class="pictrue">
            <img :src="item.image" />
          </div>
          <div class="content">
            <div class="name line1">{{ item.name }}</div>
            <div class="money font-color-red">
              ￥<span class="num">{{ item.per }}</span
              >/人
            </div>
            <div class="type">
              {{ item.cateName }} 距离{{ item.distance }}千米
            </div>
            <div class="remark">
              <span>{{
                item.remark ? "掌柜说：" + item.remark : "精选好店"
              }}</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div style="height:1.2rem;"></div>
    <div>
      <iframe
        v-if="mapKey && !isWeixin"
        ref="geoPage"
        width="0"
        height="0"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/tools/geolocation?key=' +
            mapKey +
            '&referer=myapp'
        "
      >
      </iframe>
    </div>
  </div>
</template>
<script>
import { getShare, getCityName } from "@api/public";
import { storeTypeList } from "@api/store";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import cookie from "@utils/store/cookie";
import $store from "@/store";
import { storeListApi } from "@api/store";

const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const CITY = "user_city";
const MAPKEY = "mapKey";

export default {
  name: "StoreNav",
  props: {},
  data: function() {
    return {
      showCoupon: false,
      city: "全国",
      storeList: [],
      categoryList: []
    };
  },
  mounted: function() {
    this.getHome();
  },
  methods: {
    getHome() {
      const that = this;
      let data = {
        latitude: cookie.get(LATITUDE) || "", //纬度
        longitude: cookie.get(LONGITUDE) || "", //经度
        deptId: $store.state.app.deptId,
        page: 1,
        limit: 20
      };
      storeListApi(data).then(res => {
        //获取邻近1公里内的门店列表
        if (this.$route.params.gonames === "nearby") {
          const newList = [];
          for (const item of res.data.list) {
            if (item.distance <= 1) {
              newList.push(item);
            }
          }
          this.storeList.push.apply(this.storeList, newList);
        } else {
          this.storeList.push.apply(this.storeList, res.data.list);
        }
        that.getWXLocation();
      });
      const deptId = $store.state.app.deptId;
      storeTypeList(deptId).then(res => {
        that.$set(that, "categoryList", res.data);
      });
    },
    getWXLocation() {
      const that = this;
      if (isWeixin()) {
        wxShowLocation().then(res => {
          that.city = res;
        });
      } else {
        if (!this.mapKey)
          return this.$dialog.error(
            "暂无法使用地图定位功能，请配置您的腾讯地图key"
          );
        let loc;
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data;
            if (loc && loc.module === "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
              getCityName(loc.lat, loc.lng)
                .then(res => {
                  const city = res.data.result.ad_info.city;
                  cookie.set(CITY, city);
                  that.city = city;
                })
                .catch(err => {
                  console.log(err);
                });
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              cookie.remove(CITY);
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    setOpenShare: function() {
      if (isWeixin()) {
        getShare().then(res => {
          const data = res.data.data;
          const configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>
<style scoped>
.index {
  background-color: #fff;
}
</style>
